// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__GQ3jW","load8":"Spinner_load8__Osduh","spinnerText":"Spinner_spinnerText__hvwOe"};